var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "bar-graph-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "bar-graph-range-inputs-container"
    }
  }, _vm._l(_vm.config.data, function (key, index) {
    var _key$icon;
    return _c('bar-graph-range-input', {
      key: key.label,
      attrs: {
        "ariaLabel": ((key.label) + "'s " + (_vm.config.xAxis.label) + "'"),
        "barColor": key.color,
        "icon": (_key$icon = key.icon) === null || _key$icon === void 0 ? void 0 : _key$icon.image.src,
        "isDisabled": _vm.rangeInputData[key.label].isCorrect,
        "isLastKey": index === _vm.config.data.length - 1,
        "label": key.label,
        "on-selection-start": _vm.handleOnSelectionStart,
        "on-selection-end": _vm.handleOnSelectionEnd,
        "xAxisData": _vm.config.xAxis
      },
      model: {
        value: _vm.rangeInputData[key.label].value,
        callback: function ($$v) {
          _vm.$set(_vm.rangeInputData[key.label], "value", $$v);
        },
        expression: "rangeInputData[key.label].value"
      }
    });
  }), 1), _c('div', {
    style: {
      height: '100%',
      position: 'absolute',
      top: '0',
      zIndex: 0,
      width: '100%'
    }
  }, [_c('bar-graph-y-axis', {
    attrs: {
      "currentLabel": _vm.currentLabel,
      "yAxisKeys": _vm.config.data,
      "yAxisLabel": _vm.config.yAxis.label
    }
  })], 1), _c('div', {
    style: {
      height: '100%',
      position: 'absolute',
      top: '0',
      zIndex: 0,
      width: '100%'
    }
  }, [_c('bar-graph-background', {
    attrs: {
      "currentColumn": _vm.currentColumn,
      "currentHintColumn": _vm.showHints ? _vm.currentHintColumn : undefined,
      "graphDataSummary": _vm.graphDataSummary,
      "previousLabel": _vm.previousLabel,
      "showErrors": _vm.showErrors,
      "xAxisData": _vm.config.xAxis
    }
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }